(function($) {
  const $gallery = $('.block-gallery');

  if (!$gallery.length) return

  const $menu = $gallery.find('.block-gallery__menu');
  const $list = $gallery.find('.block-gallery__list');
  var category = '.item';

  $list.isotope({
    itemSelector: '.block-gallery__item',
    layoutMode: 'masonry'
  })

  $menu.on('click', '.tab', event => {
    event.preventDefault();
    var selector = event.currentTarget.dataset.filter;
    centeringActiveTab(event.currentTarget)
    filter(selector);
  })

  $list.on('click', '.js-gallery-lightbox-link', event => {
    event.preventDefault();
    var _this = event.currentTarget;
    var index = $(_this).parents('.block-gallery__item').index(category);

    var images = $list.find('.block-gallery__item').filter(category).find('img');
    var imageset = [];

    images.each(function() {
      imageset.push({
        src: this.getAttribute('data-original-src'),
        opts: {
          $thumb: $(this),
          thumb: this.getAttribute('src'),
          caption: this.getAttribute('alt')
        }
      })
    });

    $.fancybox.open(imageset, {}, index);
  })

  function filter(selector) {
    category = selector;
    $list.isotope({
      filter: selector
    })

    var $tab = $menu.find(`[data-filter]`)
    $tab.filter(`[data-filter="${selector}"]`)
      .addClass('active')
      .attr('aria-selected', true)
    $tab.filter(`:not([data-filter="${selector}"])`)
      .removeClass('active')
      .attr('aria-selected', false)
  }

  function centeringActiveTab( tab ) {
    var rect = tab.getBoundingClientRect()
    var win = window.innerWidth / 2
    var SimpleBar = $menu[0].SimpleBar
    var wrapper = SimpleBar.getScrollElement()

    wrapper.scroll({
      behavior: 'smooth',
      left: rect.width / 2 + SimpleBar.scrollbarWidth + tab.offsetLeft - win
    })
  }

  function stringToClassName( string ){
    var className = string;
    var isClassName = string.indexOf('.') == 0 ? true : false;
    if (!isClassName) {
      className = '.' + string;
    }
    return className;
  }

  if (window.location.hash) {
    window.addEventListener('DOMContentLoaded', () => {
      var hash = window.location.hash.slice('1');
      var tab = $(`[data-filter="${stringToClassName(hash)}"]`).get(0)
      filter( stringToClassName(hash) );
      centeringActiveTab( tab );
    })
  }
})(jQuery);